export default class SubventionNumberValidator {
    constructor(number) {
        this.number = number;
        this.sanitizedNumber = number.replaceAll(/\s/g,'');
        const regex = new RegExp('^([0-9]{1,10})\\/([0-9]{1,8})\\/([0-9]{1,4})\\-([0-9]{1})\\/([0-9]{1})\\/([0-9]{1})$');
        this.matches = this.sanitizedNumber.match(regex);
        if(null === this.matches) {
            return false;
        }
    }

    isValid() {
        return null !== this.matches && this.isValidChildCheckSum() && this.isValidApplicationCheckSum();
    }
    isValidApplicationCheckSum() {
        return null !== this.matches && this.checksum(this.matches[2]) === parseInt(this.matches[5]);
    }
    isValidChildCheckSum() {
        return null !== this.matches && this.checksum(this.matches[1]) === parseInt(this.matches[4]);
    }

    checksum(value)
    {
        let sum = 0;
        for (let i = 0; i < value.length; i++) {
            let factor = i % 2 === 0 ? 3 : 1;
            let position = value.length - 1 - i;
            sum += factor * parseInt(value.charAt(position));
        }

        return sum % 10 === 0 ? 0 : 10 - sum % 10;
    }
}
